// Admin feature components
import { defineAsyncComponent } from 'vue'

export default {
  AdminApiKeysPage: defineAsyncComponent(
    () => import('../admin/api_keys/page.vue')
  ),
  AdminBudgetsIndex: defineAsyncComponent(
    () => import('../admin/budgets/index.vue')
  ),
  AdminMarketPricesPage: defineAsyncComponent(
    () => import('../admin/market_prices/index.vue')
  ),
  AdminNestPage: defineAsyncComponent(() => import('../admin/nest/index.vue')),
  AdminNestSensors: defineAsyncComponent(
    () => import('../admin/nest/sensors.vue')
  ),
  AdminNestSensorData: defineAsyncComponent(
    () => import('../admin/nest/sensor_data.vue')
  ),
  AdminNotificationReportsPage: defineAsyncComponent(
    () => import('../admin/notification_reports/page.vue')
  ),
  AdminProductionDaysPage: defineAsyncComponent(
    () => import('../admin/production_days/index.vue')
  ),
  AdminProductionPeriodsPage: defineAsyncComponent(
    () => import('../admin/production_periods/index.vue')
  ),
  AdminProductionSchedulingPage: defineAsyncComponent(
    () => import('../admin/production_scheduling/index.vue')
  ),
  AdminSupplierEdit: defineAsyncComponent(
    () => import('../admin/supplier_edit.vue')
  ),
  AdminSupplierForm: defineAsyncComponent(
    () => import('../admin/supplier_form.vue')
  ),
  AdminSuppliersTable: defineAsyncComponent(
    () => import('../admin/suppliers_table.vue')
  ),
  AdminTimeSeriesTrackerShow: defineAsyncComponent(
    () => import('../admin/time_series_trackers/show.vue')
  ),
  AdminTimeSeriesTrackers: defineAsyncComponent(
    () => import('../admin/time_series_trackers/index.vue')
  ),
  AdminUserTable: defineAsyncComponent(() => import('../admin/user_table.vue')),
  AdminUserUnlock: defineAsyncComponent(
    () => import('../admin_user_unlock.vue')
  ),
  NotificationsHubPage: defineAsyncComponent(
    () => import('../admin/notification_reports/page.vue')
  ),
  PageHitsTable: defineAsyncComponent(
    () => import('../page_hits/page_hits_table.vue')
  )
}
